export const theme = {
	color: {
		background: "#F7F8F9",
		black: "#0F0F0F",
		purple: "#7A00AE",
		white: "#FFFFFF",
		red: "#eb3b3b",
		green: "#33AF89",
		blue: "#1F4287",
		blue0: "#DDE5EF",
		blue1: "#D7DDE5",
		blue2: "#899BB5",
		blue3: "#4D6382",
		gray: "#4D5660",
		gray0: "#3A4149",
		gray1: "#283239",
		gray2: "#A7ACB1",
		orange: "#F99601",
	},
	font: {
		primary: "museo, serif",
		secondary: "museo-sans, sans-serif",
	},
};
